import { render, staticRenderFns } from "./product-details-exclusions.vue?vue&type=template&id=19991164&scoped=true&"
import script from "./product-details-exclusions.vue?vue&type=script&lang=js&"
export * from "./product-details-exclusions.vue?vue&type=script&lang=js&"
import style0 from "./product-details-exclusions.vue?vue&type=style&index=0&id=19991164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19991164",
  null
  
)

export default component.exports